const state = {
  visitedViews: [],
  visitedViewsStack: [],
  cachedViews: [] // 被缓存的view组件名称数组
}

// 过滤尾部斜杠
function filterTailSlash(path) {
  if (path.endsWith('/')) {
    return path.substr(0, path.length - 1)
  }
  return path
}

// 匹配view
export function matchView(view1, view2) {
  const path1 = filterTailSlash(view1.path)
  const path2 = filterTailSlash(view2.path)
  if (path1 !== path2) {
    return false
  }
  const query1 = view1.query
  const query2 = view2.query
  if (query1 && query1.openNew && query1.key) {
    if (query2 && query2.openNew && query2.key) {
      return query1.key === query2.key
    } else {
      return false
    }
  } else {
    if (query2 && query2.openNew && query2.key) {
      return false
    } else {
      return true
    }
  }
}

// 获取view标题
function getViewTitle(view) {
  const query = view.query
  if (query && query.openNew && query.key) {
    return query.title || query.key
  }
  return ''
}

// 刷新view（设置一个随机属性r）
export function refreshView(view) {
  if (typeof view.r === 'number') {
    view.r += 1
  } else {
    let i = state.visitedViewsStack.length - 1
    for (; i >= 0; --i) {
      const item = state.visitedViewsStack[i]
      if (matchView(item, view) && typeof item.r === 'number') {
        view.r = item.r + 1
        break
      }
    }
    if (i < 0) {
      view.r = 0
    }
  }
}

// 销毁view
export function destoryView(view) {
  if (view.instance && view.instance.$destroy) {
    view.instance.$destroy()
    delete view.instance
  }
}

const mutations = {
  ADD_VIEW: (state, view) => {
    // name+fullPath 全等时直接复用旧 view：存在同名常量路由与动态菜单路由（path 不同）的场景，
    // 仅靠 path 匹配会重复压入两个页签，合并时可顺带把旧 view 的脏 path 修正为当前路由 path
    const oldView = state.visitedViews.find(v => matchView(v, view) || (view.name && v.name === view.name && v.fullPath === view.fullPath))
    if (oldView) {
      if (view === oldView) {
        return
      }
      if (view.fullPath !== oldView.fullPath) {
        destoryView(oldView)
        // 刷新view
        oldView.r += 1
      }
      for (const key in view) {
        if (key === 'meta' || key === 'r') {
          continue
        }
        if (view[key] instanceof Object && oldView[key] instanceof Object) {
          const oldObj = oldView[key]
          const newObj = view[key]
          Object.assign(oldObj, newObj)
          Object.assign(newObj, oldObj)
        }
        oldView[key] = view[key]
      }
      return
    }
    const visitedView = { ...view, title: view.meta.title || 'no-name' }
    const title = getViewTitle(visitedView)
    if (title) {
      visitedView.meta = { ...visitedView.meta }
      visitedView.meta.enTitle = title
      visitedView.meta.title = title
    }
    refreshView(visitedView)
    state.visitedViews.push(visitedView)
    state.visitedViewsStack.push(visitedView)
    if (!view.meta.noCache && !state.cachedViews.includes(view.name)) {
      state.cachedViews.push(view.name)
    }
  },
  REPLACE_VIEW: (state, { oldView, newView }) => {
    const index = state.visitedViews.findIndex(v => matchView(v, oldView))
    if (index < 0) {
      return
    }
    if (state.visitedViews.some(v => matchView(v, newView))) {
      return
    }
    const visitedView = { ...newView, title: newView.meta.title || 'no-name' }
    const title = getViewTitle(visitedView)
    if (title) {
      visitedView.meta = { ...visitedView.meta }
      visitedView.meta.enTitle = title
      visitedView.meta.title = title
    }
    refreshView(visitedView)
    state.visitedViews.splice(index, 1, visitedView)
    state.visitedViewsStack.push(visitedView)
    if (newView.name !== oldView.name) {
      if (!oldView.meta.noCache) {
        if (state.visitedViews.some(v => v.name === oldView.name)) {
          destoryView(oldView)
        } else {
          for (const i of state.cachedViews) {
            if (i === oldView.name) {
              const index = state.cachedViews.indexOf(i)
              state.cachedViews.splice(index, 1)
              break
            }
          }
        }
      }
      if (!newView.meta.noCache && !state.cachedViews.includes(newView.name)) {
        state.cachedViews.push(newView.name)
      }
    }
  },
  DEL_VIEW: (state, view) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (matchView(v, view) || (view.name && v.name === view.name && v.fullPath === view.fullPath)) {
        state.visitedViews.splice(i, 1)
        break
      }
    }
    if (state.visitedViews.some(v => v.name === view.name)) {
      destoryView(view)
    } else {
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    }
  },
  DEL_OTHERS_VIEWS: (state, view) => {
    for (const i of state.cachedViews) {
      if (i === view.name) {
        const index = state.cachedViews.indexOf(i)
        state.cachedViews = state.cachedViews.slice(index, index + 1)
        break
      }
    }
    for (const item of state.visitedViews) {
      if (item.name === view.name && !matchView(item, view)) {
        destoryView(item)
      }
    }
    state.visitedViews = state.visitedViews.filter(v => {
      return v.meta.affix || matchView(v, view)
    })
  },
  DEL_ALL_VIEWS: state => {
    // keep affix tags
    const affixTags = state.visitedViews.filter(tag => tag.meta.affix)
    state.visitedViews = affixTags
    state.cachedViews = []
  },
  // 更新当前页签标题及query.key（用于详情页内切换业务编号时同步页签）
  UPDATE_VIEW_TITLE: (state, { view, key }) => {
    const targetView = state.visitedViews.find(v => matchView(v, view))
    if (targetView) {
      if (targetView.query) {
        targetView.query.key = key
      }
      targetView.meta = { ...targetView.meta, title: key, enTitle: key }
      targetView.title = key
    }
  }
}

const actions = {
  addView({ commit }, view) {
    commit('ADD_VIEW', view)
  },
  updateViewTitle({ commit }, payload) {
    commit('UPDATE_VIEW_TITLE', payload)
  },
  replaceView({ commit }, { oldView, newView }) {
    commit('REPLACE_VIEW', { oldView, newView })
  },
  delView({ commit, state }, view) {
    commit('DEL_VIEW', view)
    return new Promise(resolve => {
      resolve({ visitedViews: state.visitedViews })
    })
  },
  delOthersViews({ commit, state }, view) {
    commit('DEL_OTHERS_VIEWS', view)
    return new Promise(resolve => {
      resolve({ visitedViews: state.visitedViews })
    })
  },
  delAllViews({ commit, state }) {
    commit('DEL_ALL_VIEWS')
    return new Promise(resolve => {
      resolve({ visitedViews: state.visitedViews })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
